export const EXPAND_ADD_CARD = 'expandAddCard';
